import { memo } from "react"
import { ReactSVG } from "react-svg"
import cn from "clsx"
import styles from "./styles.module.scss"
import SbEditable from "storyblok-react"
import type { HTMLAttributes } from "react"
import type { SbEditableContent } from "storyblok-react"
import type { Activity as ActivityProps } from "storyblok/schema"


interface CardProps
extends HTMLAttributes<HTMLDivElement>, SbEditableContent, ActivityProps {
  active: boolean
}

const ORIGINAL_URI_BASE = 'https://a.storyblok.com'
const DIRECT_URI_BASE = 'https://s3.amazonaws.com/a.storyblok.com'

export const Card = memo<CardProps>(({
  name, icon, description,
  component, _uid, _editable,
  active, className, ...rest
}) => (
  <SbEditable content={{ component, _uid, _editable }}>
    <div {...rest} className={cn(styles.card, className, {[styles.active]: active})}>
      <ReactSVG className={styles.icon} wrapper="span"
        src={icon.filename.replace(ORIGINAL_URI_BASE, DIRECT_URI_BASE)} />
      <h3 className={styles.title}>{name}</h3>
      <p className={styles.text}>{description}</p>
    </div>
  </SbEditable>
))

Card.displayName = 'Card'
